<template>
  <v-form @submit.prevent="getActionMethod">
    <v-card>
      <v-card-text class="px-3">
        <v-row class=" mx-2">
          <span class="red--text font-weight-bold">{{
            formValidator.getError("non_field_errors")
          }}</span>
          <v-col
            cols="12"
            class="blue-grey--text text--darken-2 font-weight-bold body-1 pt-0"
          >
            Basic Information
          </v-col>
          <v-col cols="12" md="2" class="pt-0 pr-0">
            <!-- <div>
              <span>
                <v-icon
                  color="grey"
                  small
                  v-text="$getIcon('mdiFileImageOutline')"
                ></v-icon>
              </span>
              <span class="caption font-weight-bold mb-0">
                Contact Person Image:
              </span>
            </div> -->
            <vue-image-upload
              v-if="featuredImage.dialog"
              v-model="formValues.image"
              profile
              @close="featuredImage.dialog = false"
            ></vue-image-upload>
            <div v-if="featuredImage.url" class="text-center">
              <v-hover>
                <v-img
                  slot-scope="{ hover }"
                  :src="featuredImage.url"
                  style="height: 100px; border-radius: 100%; width: 100px; border:2px solid #efefef;"
                >
                  <v-expand-transition>
                    <div
                      v-if="hover"
                      class="pointer d-flex transition-fast-in-fast-out display-3 white--text"
                      @click="featuredImage.url = ''"
                    >
                      <v-icon
                        color="grey"
                        size="30"
                        v-text="$getIcon('mdiClose')"
                      ></v-icon>
                    </div>
                  </v-expand-transition>
                </v-img>
              </v-hover>
            </div>
            <div v-else-if="formValues.image" class="text-center">
              <v-hover>
                <v-img
                  slot-scope="{ hover }"
                  :src="formValues.image"
                  style="height: 80px; border-radius: 100%; width: 80px; border:2px solid #efefef;"
                >
                  <v-expand-transition>
                    <div
                      v-if="hover"
                      class="pointer d-flex transition-fast-in-fast-out display-3 white--text"
                      @click="
                        (formValues.image = ''), (featuredImage.dialog = false)
                      "
                    >
                      <v-icon
                        color="grey"
                        size="30"
                        v-text="$getIcon('mdiClose')"
                      ></v-icon>
                    </div>
                  </v-expand-transition>
                </v-img>
              </v-hover>
            </div>
            <v-responsive
              v-else
              style="height: 80px; border-radius: 100%; width: 80px; border:2px solid #efefef;"
              class="pa-1 ma-1 grey lighten-3 pointer"
              @click="featuredImage.dialog = true"
            >
              <v-row justify="center" align="center">
                <v-col cols="12" class="px-0 pb-0 text-center">
                  <v-icon
                    color="grey"
                    size="25"
                    v-text="$getIcon('mdiUpload')"
                  ></v-icon>
                </v-col>
                <v-col
                  cols="12"
                  class="text-center caption grey--text pa-0"
                  v-text="'Image'"
                ></v-col>
              </v-row>
            </v-responsive>
          </v-col>

          <v-col cols="12" md="3">
            <div>
              <span>
                <v-icon
                  color="grey"
                  small
                  v-text="$getIcon('mdiAccountBoxOutline')"
                ></v-icon>
              </span>
              <span class="caption font-weight-bold mb-0">
                Full Name:
              </span>
            </div>
            <v-text-field
              class="pt-0"
              v-model="formValues.name"
              placeholder="Full Name"
              :error-messages="formValidator.getError('name')"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <div>
              <span>
                <v-icon
                  color="grey"
                  small
                  v-text="$getIcon('mdiDomain')"
                ></v-icon>
              </span>
              <span class="caption font-weight-bold mb-0">
                Client Name:
              </span>
            </div>
            <v-text-field
              v-if="isClientData"
              class="pt-0"
              disabled
              v-model="formValues.client.name"
              placeholder="Full Name"
            ></v-text-field>
            <v-autocomplete
              v-else
              v-model="formValues.client"
              :items="clients"
              label="Search client"
              :search-input.sync="clientSearchQuery"
              item-text="name"
              item-value="slug"
              :loading="clientsLoading"
              clearable
              return-object
              style="padding: unset"
            >
              <template
                v-slot:append-outer
                v-if="$auth.strategy.name === 'realHrSoft'"
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      v-on="on"
                      @click="showFederatedClientSelect = true"
                    >
                      <v-icon v-text="$getIcon('mdiDomain')" color="blue">
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Select Fedareted Client</span>
                </v-tooltip>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="4">
            <div>
              <span>
                <v-icon
                  color="grey"
                  small
                  v-text="$getIcon('mdiBriefcaseAccountOutline')"
                ></v-icon>
              </span>
              <span class="caption font-weight-bold mb-0">
                Designation:
              </span>
            </div>
            <v-autocomplete
              v-model="formValues.designation"
              :items="designations"
              placeholder="Designation"
              :search-input.sync="designationSearchQuery"
              item-text="name"
              item-value="id"
              :loading="designationsLoading"
              clearable
              style="padding: unset"
            >
              <template v-slot:append-outer>
                <v-btn icon class="">
                  <v-icon
                    color="blue"
                    v-text="$getIcon('mdiPlusBox')"
                    @click="designationDialog = true"
                  ></v-icon>
                </v-btn>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="grey lighten-3">
          <v-col md="12" class="mx-6">
            <v-row
              ><v-col
                cols="12"
                class="body-1 font-weight-bold blue-grey--text text--darken-3"
              >
                Contact Details
              </v-col>
            </v-row>
            <v-row v-if="formValues.medium_contacts.length">
              <v-col
                v-for="(contactInfo, index) in formValues.medium_contacts"
                :key="index"
                class="py-0"
                cols="12"
              >
                <v-row align="center">
                  <v-col cols="12" md="4" class="py-0">
                    <div>
                      <span>
                        <v-icon color="grey" small>{{
                          $options.mediumIcons[contactInfo.icon_name]
                        }}</v-icon>
                      </span>
                      <span class="caption font-weight-bold mb-0">
                        {{ contactInfo.label_name }}:
                      </span>
                    </div>
                    <v-text-field
                      :placeholder="contactInfo.label_name"
                      v-model="formValues.medium_contacts[index].contact"
                      :error-messages="formValidator.getError('contact')"
                      required
                      class="mr-2 pt-0"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="10" md="4" class="py-0">
                    <div>
                      <span>
                        <v-icon
                          color="grey"
                          small
                          v-text="$getIcon('mdiInformationOutline')"
                        ></v-icon>
                      </span>
                      <span class="caption font-weight-bold mb-0">
                        Label:
                      </span>
                    </div>
                    <v-autocomplete
                      placeholder="Select contact label"
                      :items="
                        organizationLabels.filter(
                          o =>
                            o.communication_medium_id ===
                            formValues.medium_contacts[index].medium
                        )
                      "
                      v-model="formValues.medium_contacts[index].label"
                      :error-messages="formValidator.getError('label')"
                      item-text="label"
                      item-value="id"
                      required
                      class="pt-0"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="2" class="py-0">
                    <v-icon
                      class="pointer"
                      color="red lighten-2"
                      @click="removeContact(index)"
                      v-text="$getIcon('mdiTrashCanOutline')"
                    >
                    </v-icon
                  ></v-col> </v-row
              ></v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="body-2 font-weight-bold">
                Add Fields
              </v-col>
            </v-row>
            <v-row class="mb-10">
              <v-col
                v-for="(medium, index) in availableMediums"
                :key="index"
                md="1"
                cols="3"
                class="text-center pointer"
              >
                <v-card
                  outlined
                  :class="
                    `elevation-${
                      medium.id === formValues.medium
                        ? `1 blue darken-2`
                        : `1 grey lighten-3`
                    }`
                  "
                  class="pointer"
                  @click="(formValues.medium = medium.id), addForm(medium)"
                >
                  <v-card-text class="px-0">
                    <v-icon
                      :color="
                        medium.id === formValues.medium
                          ? 'white'
                          : 'blue darken-2'
                      "
                      size="25"
                    >
                      {{ $options.mediumIcons[medium.icon] }}
                    </v-icon>
                  </v-card-text>
                </v-card>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-hover>
                      <div
                        v-on="on"
                        class="caption font-weight-bold pointer mt-1"
                        @click="
                          $set(formValues, 'medium', medium.id),
                            (communicationMediums = [...communicationMediums])
                        "
                      >
                        {{ truncate(medium.name, 9) }}
                      </div>
                    </v-hover>
                  </template>
                  <span>{{ medium.name }}</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <v-footer class="white pt-0" fixed height="60">
        <v-row>
          <v-col class="text-right" md="12">
            <v-btn @click="$emit('close')" text class="grey--text">
              Cancel
            </v-btn>
            <v-btn
              v-if="!formValues.id"
              color="primary"
              outlined
              @click="addAnother()"
              :disabled="loading"
            >
              Save & Add Another
            </v-btn>
            <v-btn
              :disabled="
                Object.keys(formValidator.errors).length > 0 || loading
              "
              class="primary"
              @click="getActionMethod()"
              :loading="loading"
            >
              Save
            </v-btn>
          </v-col>
        </v-row>
      </v-footer>
    </v-card>
    <v-dialog v-model="designationDialog" width="400">
      <v-card>
        <vue-card-title
          title="Create New Designation"
          subtitle="Create New Designation"
          :icon="$getIcon('mdiFileDocumentEdit')"
          closable
          @click="designationDialog = false"
          @close="designationDialog = false"
        >
        </vue-card-title>
        <v-divider></v-divider>
        <v-card-text class="my-5">
          <v-text-field
            v-model="designation"
            label="Designation"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-col class="text-right">
            <v-btn
              class="text-capitalize"
              text
              @click="designationDialog = false"
            >
              Cancel
            </v-btn>
            <v-btn
              depressed
              color="red darken-4"
              class="white--text text-capitalize"
              @click="createDesignation"
              :loading="loading"
              :disabled="loading"
            >
              Save
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>
</template>
<script>
import { FormValidator } from "rhr-core-shell";
import mediumIcons from "@/utils/mediumIcons.js";
import cancelRequestMixin from "@/mixins/cancelRequestMixin";
import isEmpty from "lodash/isEmpty";
export default {
  mediumIcons,
  resourceUrl: "/api/v1/crm/client-contact-person-medium-contacts/",
  mediumLabelResourceUrl: "/api/v1/crm/communication-mediums-labels/",
  components: {},
  mixins: [cancelRequestMixin],
  props: {
    actionData: {
      type: Object,
      required: false,
      default() {
        return {};
      }
    },
    client: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      designationEndpoint: `/api/v1/crm/client-designation/?organization__slug=${this.$store.state.shell.currentOrganizationId}`,
      clientSearchQuery: "",
      designationSearchQuery: "",
      formValues: {
        client: "",
        name: "",
        image: "",
        medium_contacts: [],
        designation: "",
        phone_numbers: [
          {
            number_type: "Mobile",
            number: ""
          }
        ]
      },
      featuredImage: {
        dialog: false,
        name: "",
        url: ""
      },
      saveAndAddAnother: false,
      clientsLoading: false,
      designationsLoading: false,
      clients: [],
      designations: [],
      isClientData: !isEmpty(this.client),
      formValidator: new FormValidator(),
      designationDialog: false,
      designation: "",
      availableMediums: [],
      medium_contacts: [],
      collapseControls: [],
      organizationLabels: [],
      loading: false
    };
  },
  watch: {
    formValues: {
      handler() {
        this.formValidator.setError({});
      },
      deep: true
    },
    designationDialog(val) {
      if (!val) this.designation = "";
    },
    actionData: {
      handler(val) {
        if (Object.keys(val).length) {
          this.populateData();
        } else {
          this.clearForm();
        }
      },
      immediate: true,
      deep: true
    },
    client: {
      handler(val) {
        if (Object.keys(val).length) {
          this.formValues.client = val;
        }
      },
      immediate: true
    },
    clientSearchQuery: function(newVal) {
      if (newVal?.length > 1) {
        this.getClients();
      }
    },
    designationSearchQuery: function(newVal) {
      if (newVal?.length > 1) {
        this.getDesignation();
      }
    }
  },
  mounted() {
    this.fetchMediums();
    this.fetchOrganizationLabels();
    this.getDesignation();
  },
  computed: {
    contactsByMedium() {
      return mediumId => {
        return this.medium_contacts.filter(obj => {
          return obj.medium === mediumId;
        });
      };
    }
  },
  methods: {
    populateData() {
      if (!this.actionData.phone_numbers.length) {
        this.actionData.phone_numbers = [
          {
            number_type: "Mobile",
            number: ""
          }
        ];
      }
      this.formValues.designation = null;
      if (this.actionData.designation) {
        this.formValues.designation = this.actionData.designation.id;
        this.getDesignation();
      }
      this.formValues.id = this.actionData.id;
      this.formValues.image = this.actionData.image;
      this.formValues.medium_contacts = this.actionData.medium_contacts;
      this.formValues.name = this.actionData.name;
      this.formValues.client = {
        name: this.actionData.client_name,
        slug: this.actionData.client
      };
    },
    addAnother() {
      (this.saveAndAddAnother = true), this.getActionMethod();
    },
    getActionMethod() {
      this.loading = true;
      if (this.formValues.id) return this.updateContactPerson();
      return this.createContactPerson();
    },
    createFormValues() {
      const postData = JSON.parse(JSON.stringify(this.formValues));
      postData.client = this.formValues.client.slug;
      return postData;
    },
    createContactPerson() {
      this.loading = false;
      if (
        this.formValues.medium_contacts.length &&
        this.formValues.medium_contacts.filter(
          each => !(each.contact && each.label)
        ).length
      ) {
        this.$store.dispatch("shell/showSnackbar", {
          text: `Please fill up the contact details first`
        });
      } else {
        const contactPersonAPI = "/api/v1/crm/client-contact-person/";
        this.$axios
          .$post(contactPersonAPI, this.createFormValues())
          .then(() => {
            this.$store.dispatch("shell/showSnackbar", {
              text: `Successfully created client contact person!`,
              color: "green"
            });

            if (this.saveAndAddAnother) {
              this.clearForm();
              this.saveAndAddAnother = false;
              this.$emit("contactPersonFormResponse");
            } else {
              this.postContactPersonContacts();
            }
          })
          .catch(error => {
            this.formValidator.setError(error.response.data);
          });
      }
    },
    clearForm() {
      this.formValues = {
        name: "",
        client: "",
        image: "",
        medium_contacts: [],
        designation: "",
        phone_numbers: [
          {
            number_type: "Mobile",
            number: ""
          }
        ]
      };
      if (Object.keys(this.client).length) {
        this.formValues.client = this.client;
      }
    },
    updateContactPerson() {
      this.loading = false;
      const contactPersonAPI =
        "/api/v1/crm/client-contact-person/" + this.formValues.id + "/";
      var patchedData = JSON.parse(JSON.stringify(this.formValues));
      patchedData.client = patchedData.client.slug;
      if (this.actionData.image === patchedData.image) {
        delete patchedData.image;
      }
      if (
        patchedData.medium_contacts.length &&
        patchedData.medium_contacts.filter(
          each => !(each.contact && each.label)
        ).length
      ) {
        this.$store.dispatch("shell/showSnackbar", {
          text: `Please fill up the contact details first`
        });
      } else {
        this.$axios
          .$patch(contactPersonAPI, patchedData)
          .then(() => {
            this.postContactPersonContacts();
            this.$store.dispatch("shell/showSnackbar", {
              text: `Successfully updated client contact person!`,
              color: "green"
            });
          })
          .catch(error => {
            this.formValidator.setError(error.response.data);
            patchedData.image = this.actionData.image;
          });
      }
    },
    postContactPersonContacts() {
      this.$emit("close");
      this.$emit("contactPersonFormResponse");
    },
    createDesignation() {
      this.loading = true;
      this.$axios
        .$post(this.designationEndpoint, {
          name: this.designation,
          organization: this.$store.state.shell.currentOrganizationId
        })
        .then(response => {
          this.loading = false;
          this.$store.dispatch("shell/showSnackbar", {
            text: `Successfully created Designation ${this.formValues.designation}!`
          });
          this.formValues.designation = response;
          this.designationDialog = false;
        });
    },
    async fetchMediums() {
      try {
        const { data } = await this.$axios.get(
          `/api/v1/crm/communication-mediums/choices/?fields=name,id,icon&organization__slug=${this.$store.state.shell.currentOrganizationId}`
        );
        this.availableMediums = data;
      } catch (error) {
        console.log(error); //eslint-disable-line
      }
    },
    async fetchOrganizationLabels() {
      try {
        const params = {
          communication_medium__organization__slug: this.$store.state.shell
            .currentOrganizationId
        };
        const {
          data
        } = await this.$axios.get(
          `${this.$options.mediumLabelResourceUrl}choices/`,
          { params }
        );
        this.organizationLabels = data;
      } catch (error) {
        console.log(error); //eslint-disable-line
      }
    },
    removeContact(index) {
      this.formValues.medium_contacts = this.formValues.medium_contacts.filter(
        (each, i) => {
          return index !== i;
        }
      );
    },
    truncate(text, length, suffix) {
      if (!text) return "";
      let truncatedText = "";
      suffix = suffix || "...";
      if (text.length > length) {
        truncatedText = text.substring(0, length) + suffix;
      } else {
        truncatedText = text.substring(0, length);
      }
      return truncatedText;
    },
    addForm(medium) {
      this.formValues.medium_contacts.push({
        label_name: medium.name,
        icon_name: medium.icon,
        label: "",
        medium: medium.id,
        contact: ""
      });
    },
    getClients() {
      this.clientsLoading = true;
      this.checkRequest();
      this.$axios
        .get(
          `/api/v1/crm/clients/select/?organization__slug=${this.$store.state.shell.currentOrganizationId}`,
          {
            params: {
              search: this.clientSearchQuery
            },
            cancelToken: this.axiosSource.token
          }
        )
        .then(({ data }) => {
          this.clearOldRequest("Success");
          this.clients = data;
          this.clientsLoading = false;
        });
    },
    getDesignation() {
      this.designationsLoading = true;
      this.checkRequest();
      this.$axios
        .get(this.designationEndpoint, {
          params: {
            search: this.designationSearchQuery || ""
          },
          cancelToken: this.axiosSource.token
        })
        .then(({ data }) => {
          this.clearOldRequest("Success");
          this.designations = data.results;
          this.designationsLoading = false;
        });
    }
  }
};
</script>
